var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85794 9.67517L11.4998 14.0786L14.1423 9.67517H8.85794ZM17.0946 14.2457L14.4528 9.84224L11.8102 14.2457H11.8103H17.0946ZM5.9051 14.596L8.54703 19L11.1898 14.596H5.9051ZM14.4522 19L17.0949 14.596H11.8103L14.4522 19ZM20.3575 9.15777L23 4.75425H17.7157L20.3575 9.15777ZM17.405 14.0786L20.0474 9.67517H14.7631L17.405 14.0786ZM2.64193 19L5.28449 14.596H0L2.64193 19ZM0 14.2457H5.28449L2.64256 9.84186L0 14.2457ZM20.3581 0L17.7154 4.4039H23L20.3581 0ZM17.4052 4.92129L14.7629 9.32482H20.0472L17.4052 4.92129ZM11.5004 4.92094L8.85766 9.32482H14.1423L11.5004 4.92094ZM8.5475 9.84224L5.9051 14.2457H11.1893L8.5475 9.84224Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogoDark);
export default __webpack_public_path__ + "static/media/header_logo_dark.8fdef9e0f66c0ee7175d7d66f20bafcf.svg";
export { ForwardRef as ReactComponent };